/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { GTMTrigger, GTMVariable } from '../models/Google';

// Any changes should be verified in https://console.cloud.google.com/
export const GOOGLE_ACCOUNT_SCOPES = 'email '
  + 'profile '
  + 'openid '
  + 'https://www.googleapis.com/auth/userinfo.email '
  + 'https://www.googleapis.com/auth/userinfo.profile '
  + 'https://www.googleapis.com/auth/tagmanager.readonly '
  + 'https://www.googleapis.com/auth/tagmanager.edit.containers '
  + 'https://www.googleapis.com/auth/tagmanager.edit.containerversions '
  + 'https://www.googleapis.com/auth/tagmanager.publish '
  + 'https://www.googleapis.com/auth/tagmanager.manage.users '
  + 'https://www.googleapis.com/auth/tagmanager.manage.accounts '
  + 'https://www.googleapis.com/auth/analytics.readonly '
  + 'https://www.googleapis.com/auth/analytics.edit '
  + 'https://www.googleapis.com/auth/analytics.manage.users '
  + 'https://www.googleapis.com/auth/analytics.manage.users.readonly';

export const GTM_CONTAINER_NAME_DEFAULT = 'ish onCourse Google Tag manager container';

export const GAS_VARIABLE_NAME = 'ish onCourse Google Analytics settings';

export const GA4_TAG_NAME = 'ish onCourse GA4 Configuration';

export const UA_TAG_NAME = 'ish onCourse Google Analytics';

export const UA_TAG_EVENTS_NAME = 'ish onCourse Google Analytics events';

export const getGASVariable = (trakingId: string): GTMVariable => ({
  name: GAS_VARIABLE_NAME,
  type: 'gas',
  parameter: [
    {
      key: 'cookieDomain',
      type: 'template',
      value: 'auto'
    },
    {
      key: 'useEcommerceDataLayer',
      type: 'boolean',
      value: 'true'
    },
    {
      key: 'doubleClick',
      type: 'boolean',
      value: 'false'
    },
    {
      key: 'setTrackerName',
      type: 'boolean',
      value: 'false'
    },
    {
      key: 'useDebugVersion',
      type: 'boolean',
      value: 'false'
    },
    {
      key: 'useHashAutoLink',
      type: 'boolean',
      value: 'false'
    },
    {
      key: 'decorateFormsAutoLink',
      type: 'boolean',
      value: 'false'
    },
    {
      key: 'enableLinkId',
      type: 'boolean',
      value: 'false'
    },
    {
      key: 'enableEcommerce',
      type: 'boolean',
      value: 'true'
    },
    {
      key: 'trackingId',
      type: 'template',
      value: `${trakingId}`
    }
  ],
});

export const MAPS_API_KEY_NAME = 'Google Maps API Key';

export const getMapsApiKeyVariable = (apiKey: string): GTMVariable => ({
  name: MAPS_API_KEY_NAME,
  type: 'c',
  parameter: [
    {
      type: 'TEMPLATE',
      key: 'value',
      value: apiKey
    }
  ],
  formatValue: {}
});

export const ALL_PAGES_TRIGGER_DEFAULT: GTMTrigger = {
  name: 'All pages',
  type: 'pageview',
};

export const ALL_EVENTS_TRIGGER_DEFAULT: GTMTrigger = {
  name: 'Any event',
  type: 'customEvent',
  customEventFilter: [
    {
      'type': 'equals',
      'parameter': [
        {
          'type': 'template',
          'key': 'arg0',
          'value': '{{_event}}'
        },
        {
          'type': 'template',
          'key': 'arg1',
          'value': '.*'
        }
      ]
    }
  ],
  filter: [
    {
      'type': 'startsWith',
      'parameter': [
        {
          'type': 'template',
          'key': 'arg0',
          'value': '{{Event}}'
        },
        {
          'type': 'template',
          'key': 'arg1',
          'value': 'undefined'
        },
        {
          'type': 'boolean',
          'key': 'negate',
          'value': 'true'
        }
      ]
    }
  ],
};

export const MAPS_PAGE_TRIGGER_DEFAULT: GTMTrigger = {
  name: 'Google map trigger',
  type: 'ELEMENT_VISIBILITY',
  parameter: [
    {
      type: 'TEMPLATE',
      key: 'elementId',
      value: 'gmapCanvas'
    },
    {
      type: 'BOOLEAN',
      key: 'useOnScreenDuration',
      value: 'false'
    },
    {
      type: 'BOOLEAN',
      key: 'useDomChangeListener',
      value: 'false'
    },
    {
      type: 'TEMPLATE',
      key: 'firingFrequency',
      value: 'ONCE'
    },
    {
      type: 'TEMPLATE',
      key: 'selectorType',
      value: 'ID'
    },
    {
      type: 'TEMPLATE',
      key: 'onScreenRatio',
      value: '50'
    }
  ]
};
